import React, { useState, useEffect, useCallback, useRef } from "react";

import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";

import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import Origin_icon from "../../images/origin.svg";
import Destination_icon from "../../images/destination.svg";

const RouteHeader = React.memo(({
  stops,
  route,
  pathDirection,
  translatedStopNames = {},
}) => {
  const [isReconnecting, setIsReconnecting] = useState(false);

  if (!stops || stops.length < 2) return null;
  const sourceStop =
    pathDirection === "dest_to_source" ? stops[stops.length - 1] : stops[0];
  const destinationStop =
    pathDirection === "dest_to_source" ? stops[0] : stops[stops.length - 1];
  const sourceStopName =
    translatedStopNames[String(sourceStop.name || "").trim()] ||
    sourceStop.name ||
    "Unknown";
  const destinationStopName =
    translatedStopNames[String(destinationStop.name || "").trim()] ||
    destinationStop.name ||
    "Unknown";
  const directionLabel =
    pathDirection === "dest_to_source" ? (
      <EastOutlinedIcon sx={{ width: 40, height: 40, color: "#183059" }} />
    ) : pathDirection === "source_to_dest" ? (
      <EastOutlinedIcon sx={{ width: 40, height: 40, color: "#183059" }} />
    ) : null;
  return (
    <div style={{ padding: "12px 16px" }}>
      <div
        style={{
          borderRadius: "4px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 10px",
          backgroundColor: "#E8EAEE",
          flexDirection: { xs: "column", sm: "row" },
          color: "white",
          fontWeight: "bold",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              marginRight: "10px",
              fontSize: { xs: "20px", sm: "36px" },
            }}
          >
            <img src={Origin_icon} alt="origin" />
          </span>
          <h1
            style={{ fontSize: { xs: "24px", sm: "48px" }, color: "#183059" }}
          >
            {sourceStopName}
          </h1>
        </div>
        <div
          style={{
            backgroundColor: "rgba(255,255,255,0.2)",
            padding: { xs: "8px", sm: "10px" },
            borderRadius: "4px",
            // fontSize: "42px",
          }}
        >
          {directionLabel}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              marginLeft: "10px",
              fontSize: { xs: "20px", sm: "36px" },
            }}
          >
            <img src={Destination_icon} alt="destination" />
          </span>
          <h1
            style={{
              fontSize: { xs: "4px", sm: "48px" },
              color: "#183059",
              marginLeft: "8px",
            }}
          >
            {destinationStopName}
          </h1>
        </div>
      </div>
      {isReconnecting && (
        <div
          style={{
            backgroundColor: "#FFD700",
            color: "black",
            textAlign: "center",
            padding: "5px",
            fontWeight: "bold",
          }}
        >
          Reconnecting...
        </div>
      )}
    </div>
  );
});

export default RouteHeader;
